import { createReducer, createActions } from 'reduxsauce'
import Immutable from 'seamless-immutable'
import {
  updateRequest,
  updateSuccess,
  updateFailure,
  setObject
} from './genericReducers'

/* ------------- Types and Action Creators ------------- */

const { Types, Creators } = createActions({
  contactButtonUpdateRequest: ['params', 'callback'],
  contactButtonUpdateSuccess: ['data'],
  contactButtonUpdateFailure: ['error'],

  setContactButton: ['data']
})

export const ContactButtonTypes = Types
export default Creators

/* ------------- Initial State ------------- */

export const INITIAL_STATE = Immutable({
  updateData: {},
  updateError: null,
  updateFetching: false,

  data: {}
})

/* ------------- Reducers ------------- */

export const reset = state => state.merge(INITIAL_STATE)

/* ------------- Selectors ------------- */

export const ContactButtonSelectors = {
  contactButtonId: state => state.contactButton.data.id
}

/* ------------- Hookup Reducers To Types ------------- */

export const reducer = createReducer(INITIAL_STATE, {
  [Types.CONTACT_BUTTON_UPDATE_REQUEST]: updateRequest,
  [Types.CONTACT_BUTTON_UPDATE_SUCCESS]: updateSuccess,
  [Types.CONTACT_BUTTON_UPDATE_FAILURE]: updateFailure,

  [Types.SET_CONTACT_BUTTON]: setObject
})
